import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const greaterThanValidator =
  // ----------
  // fieldNames: string[]
  // * the names of the form fields to be compared,
  // * with the expected larger value first, smaller value second
  // ----------
  // errorName: string
  // * the key string for the returned error
  // ----------

  (fieldNames: string[], errorName: string): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null => {
      const large = convertToNumber(control.get(fieldNames[0]).value);
      const small = convertToNumber(control.get(fieldNames[1]).value);

      const invalid = !!(large > small);

      return invalid ? { [errorName]: true } : null;
    };

const convertToNumber = (input: any): Date | number => {
  if (typeof input === 'string') {
    return parseInt(input, 10);
  }
  return input;
};

/**
 * Validator for US zip codes
 * Allows 5-digit format (12345) or 9-digit format (12345-6789)
 */
export const zipCodeValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Allow empty values (use Validators.required separately if needed)
    if (!value) {
      return null;
    }

    // Check for 5-digit or 9-digit (with hyphen) zip code format
    const zipCodePattern = /^(\d{5}|\d{5}-\d{4})$/;

    if (!zipCodePattern.test(value)) {
      return { invalidZipCode: true };
    }

    return null;
  };
};
